module.exports={
	"Form": "ProjectTypeEditManifest",
	"Scope": "ProjectType-Edit",
	"Descriptors":
	{
		"ProjectTypeDetails.IDProjectType":
		{
			"Name": "ID",
			"Hash": "ProjectTypeEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ProjectTypeEditIdentity",
				"Group": "ProjectTypeEditIdentity"
			}
		},
		"ProjectTypeDetails.GUIDProjectType":
		{
			"Name": "GUID",
			"Hash": "ProjectTypeEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ProjectTypeEditIdentity",
				"Group": "ProjectTypeEditIdentity"
			}
		},
		"ProjectTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "ProjectTypeEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ProjectTypeEditIdentity",
				"Group": "ProjectTypeEditIdentity"
			}
		},
		"ProjectTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "ProjectTypeEdit-Hash",
			"DataType": "String",
			"Description": "Stable short code. Referenced by a contract type's allowed-project-types list (via the ContractType AllowedProjectTypes endpoint) and CSV imports.",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "ProjectTypeEditIdentity",
				"Group": "ProjectTypeEditIdentity"
			}
		},
		"ProjectTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "ProjectTypeEdit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 6,
				"Section": "ProjectTypeEditIdentity",
				"Group": "ProjectTypeEditIdentity"
			}
		},
		"ProjectTypeDetails.Ordinal":
		{
			"Name": "Order",
			"Hash": "ProjectTypeEdit-Ordinal",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 2,
				"Section": "ProjectTypeEditIdentity",
				"Group": "ProjectTypeEditIdentity"
			}
		},
		"ProjectTypeDetails._DisplaySettings.AvailableStatusList":
		{
			"Name": "Available Statuses",
			"Hash": "ProjectTypeEdit-AvailableStatusList",
			"DataType": "String",
			"Description": "Lifecycle statuses a project of this type can occupy, in display order. Type a status name and press Enter to add it. The Project Transition form uses this list as the destination-status picker.",
			"PictForm":
			{
				"InputType": "Select2Multiple",
				"AllowCustomValues": true,
				"Row": "2",
				"Width": 6,
				"Section": "ProjectTypeEditSettings",
				"Group": "ProjectTypeEditSettings"
			}
		},
		"ProjectTypeDetails._DisplaySettings.StatusesRequiringChangeOrder":
		{
			"Name": "Statuses Requiring Change Order",
			"Hash": "ProjectTypeEdit-StatusesRequiringChangeOrder",
			"DataType": "String",
			"Description": "When a project is in one of these statuses, line-item edits must go through the Change Order flow in Contract Admin. Type a status name and press Enter to add it.",
			"PictForm":
			{
				"InputType": "Select2Multiple",
				"AllowCustomValues": true,
				"Row": "3",
				"Width": 6,
				"Section": "ProjectTypeEditSettings",
				"Group": "ProjectTypeEditSettings"
			}
		},
		"ProjectTypeDetails._DisplaySettings.DefaultDates":
		{
			"Name": "Default Project Dates",
			"Hash": "ProjectTypeEdit-DefaultDates",
			"DataType": "Array"
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProjectTypeEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProjectTypeEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Settings",
			"Hash": "ProjectTypeEditSettings",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Settings",
					"Hash": "ProjectTypeEditSettings",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Default Project Dates",
			"Hash": "ProjectTypeEditDefaultDates",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Default Project Dates",
					"Hash": "ProjectTypeEditDefaultDatesGrid",
					"Layout": "Tabular",
					"RecordSetSolvers": [],
					"RecordSetAddress": "ProjectTypeDetails._DisplaySettings.DefaultDates",
					"RecordManifest": "ProjectTypeDefaultDateRow",
					"ShowTitle": false
				}
			]
		}
	],
	"ReferenceManifests":
	{
		"ProjectTypeDefaultDateRow":
		{
			"Scope": "ProjectTypeDefaultDateRow",
			"Descriptors":
			{
				"Hash":
				{
					"Name": "Hash",
					"Hash": "ProjectTypeDefaultDateRowHash",
					"DataType": "String",
					"Description": "Stable short code for the date milestone (e.g. NTP, SUBCMP).",
					"PictForm":
					{
						"InputType": "Text",
						"Section": "ProjectTypeEditDefaultDates",
						"Group": "ProjectTypeEditDefaultDatesGrid"
					},
					"IsTabular": true
				},
				"Name":
				{
					"Name": "Display Name",
					"Hash": "ProjectTypeDefaultDateRowName",
					"DataType": "String",
					"Description": "Human-readable label shown to users (e.g. 'Notice to Proceed').",
					"PictForm":
					{
						"InputType": "Text",
						"Section": "ProjectTypeEditDefaultDates",
						"Group": "ProjectTypeEditDefaultDatesGrid"
					},
					"IsTabular": true
				}
			}
		}
	}
}
